import _moment from "moment";
// import JSEncrypt from "jsencrypt/bin/jsencrypt";
// import user from "./user.js";
import numberUtils from "./numberUtils.js";

const toNonExponential = (value) => {
    return toNonExponentialByValue(value);
}
const toNonExponentialRow = (row, column, cellValue) => {
    return toNonExponentialByValue(cellValue);
}

const toNonExponentialByValue = (value) => {
    return toNonExponentialByValueAndFixed(value, 6);
}

const toNonExponentialByValueAndFixed = (value, fixed) => {
    if (value == undefined) {
        return "";
    }
    var m = value.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
    var b = value.toFixed(fixed);
    return parseFloat(b).toFixed(Math.max(0, (m[1] || '').length - m[2]));
}

const secondsFormatRow = (row, column, cellValue) => {
    var data = row[column.property];
    if (data == undefined || data == "0") {
        return "0";
    }
    return secondsFormat(data);
}

const secondsFormat = (data) => {
    if (data == undefined || data == null || data == "0") {
        return "0";
    }
    var theTime = parseInt(data);
    var theTime1 = 0;
    var theTime2 = 0;
    var theTime3 = 0;
    if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60);
            theTime1 = parseInt(theTime1 % 60);
            if (theTime2 > 24) {

                theTime3 = parseInt(theTime2 / 24);
                theTime2 = parseInt(theTime2 % 24);
            }
        }
    }
    var result = "";
    if (theTime > 0) {
        result = "" + parseInt(theTime) + "秒";
    }
    if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + "分" + result;
    }
    if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + "小时" + result;
    }
    if (theTime3 > 0) {
        result = "" + parseInt(theTime3) + "天" + result;
    }
    return result;
}

const dateTimeFormatRow = (row, column, cellValue) => {
    if (!cellValue) {
        return ''
    }
    return dateFormatByDate(cellValue);
}

const dateFormatRow = (row, column, cellValue) => {
    if (!cellValue) {
        return ''
    }
    return dateFormatByDateAndPattern(cellValue, "YYYY-MM-DD");
}

const dateFormatByDate = (date) => {
    if (!date) {
        return ''
    }

    return dateFormatByDateAndPattern(date, "YYYY-MM-DD HH:mm:ss");
}

const dateFormatByDateAndPattern = (date, pattern) => {
    if (!date) {
        return ''
    }
    return _moment(date).format(pattern)
}

const dateSecondsFormatRow = (row, column, cellValue) => {
    if (!cellValue) {
        return ''
    }
    return dateFormatByDate(cellValue * 1000);
}

const dateSecondsFormatByDate = (timeStamp) => {
    if (!timeStamp) {
        return ''
    }

    return dateFormatByDateAndPattern(timeStamp * 1000, "YYYY-MM-DD HH:mm:ss");
}

const getBeijingTime = (currentDate) => {

    var d = new Date();

    // var tmpHours = currentDate.getHours();

    var time_zone = -d.getTimezoneOffset() / 60;
    // if (time_zone < 0) {
    //   time_zone = Math.abs(time_zone) + 8;
    //   currentDate.setHours(tmpHours + time_zone);
    // } else {
    //   time_zone -= 8;
    //   currentDate.setHours(tmpHours - time_zone);
    // }

    currentDate.setHours(currentDate.getHours() + time_zone);
    return currentDate;
}

const optionsFormat = (value, options, defaultValue) => {
    if (!!options && Array.isArray(options)) {
        options.forEach(v => {
            if (v.value === value) {
                defaultValue = v.label;
            }
        });
    }

    return defaultValue;
}

const jsonFormat = (key, jsonStr, defaultValue) => {
    try {
        let json = JSON.parse(jsonStr);
        if (json[key] != undefined) {
            defaultValue = json[key];
        }
    } catch (error) {}

    return defaultValue;
}

const symbolFormat = (symbol) => {
    if (!symbol) {
        return 4
    }
    symbol = symbol.toLowerCase()
    if (symbol == 'usdt' || symbol == 'husd' || symbol == 'dmc') {
        return 2
    }
    if (symbol == 'hfil' || symbol == 'fil') {
        return 4
    }
    if (symbol == 'xch' || symbol == 'ixch') {
        return 6
    }
    return 2

}

const symbolFormatBylimit = (data, symbol, r) => {
    return numberUtils.format(data, symbolFormat(symbol), r);

}



// const pwdFormat = async (data) => {
//   let res = await user.Key();
//   let encryptor = new JSEncrypt();
//   encryptor.setPublicKey(res.result.publickey);
//   return encryptor.encrypt(data);
// }

// const pwdFormatByPreKey = async (preKey, data) => {
//   let res = await user.KeyV2(preKey);
//   let encryptor = new JSEncrypt();
//   encryptor.setPublicKey(res.result.publickey);
//   return encryptor.encrypt(data);
// }

/**
 * https://github.com/13601313270/vue-format#readme
 * cnpm install vue-text-format -S
 * main.js
 * import format from 'vue-text-format';
 * Vue.use(format);
 */
const textFormat = (_this, value, pattern) => {
    // if (pattern != null) {
    //   if (typeof value == 'number') {
    //     if (pattern.indexOf(',') >= 0 && value < 1000) {
    //       pattern = pattern.replace(",", "");
    //     }
    //   }
    // }
    return _this.textFormat(value, pattern);
}

const powerFormatRow = (row, column, cellValue) => {
    var data = row[column.property];
    if (data == undefined || data == "0") {
        return "0";
    }
    return powerFormat(data);
}

const powerFormat = (data) => {
    return powerFormatByUnit(data, POWER_UNIT_GIB);
}

const powerFormatByUnit = (data, unit) => {
    return powerFormatByUnitAndPrecision(data, unit, 18, 4);
}

const powerFormatByPrecision = (data, n, r) => {
    return powerFormatByUnitAndPrecision(data, POWER_UNIT_GIB, n, r);
}

const powerFormatByUnitAndPrecision = (data, unit, n, r) => {
    if (data == undefined || data == "0" || !data) {
        return "0 " + getUnitStr(unit);
    }
    if ((data >= 1 && data < 1024) || unit <= POWER_UNIT_BIT || unit >= POWER_UNIT_DIB) {
        return numberUtils.format(data, n, r) + " " + getUnitStr(unit);
    }
    if (data < 1) {
        return powerFormatByUnitAndPrecision(numberUtils.mul(data, 1024), unit - 1, n, r);
    }
    if (data >= 1024) {
        return powerFormatByUnitAndPrecision(numberUtils.div(data, 1024, 48), unit + 1, n, r);
    }

    return ""
}

const getUnitStr = (unit) => {
    switch (unit) {
        case POWER_UNIT_BIT:
            return 'BiT';
        case POWER_UNIT_KIB:
            return 'KiB';
        case POWER_UNIT_MIB:
            return 'MiB';
        case POWER_UNIT_GIB:
            return 'GiB';
        case POWER_UNIT_TIB:
            return 'TiB';
        case POWER_UNIT_PIB:
            return 'PiB';
        case POWER_UNIT_EIB:
            return 'EiB';
        case POWER_UNIT_ZIB:
            return 'ZiB';
        case POWER_UNIT_YIB:
            return 'YiB';
        case POWER_UNIT_BIB:
            return 'BiB';
        case POWER_UNIT_NIB:
            return "NiB";
        case POWER_UNIT_DIB:
            return "DiB";
        default:
            return '';
    }
}

const powerFormatByPowerPrecision = (data, power, n, r) => {
    return powerFormatByPowerUnitAndPrecision(data, power, POW_POWER_UNIT_GH, n, r);
}

const powerFormatByPowerUnitAndPrecision = (data, power, unit, n, r) => {

    if (data == undefined || data == "0" || !data) {
        return "0 " + getUnitStr1(unit);
    }
    if ((Number(data) >= 1 && Number(data) < Number(power)) || unit <= POW_POWER_UNIT_HASH || unit >= POW_POWER_UNIT_DH) {

        return numberUtils.format(data, n, r) + " " + getUnitStr1(unit);
    }
    if (Number(data) < 1) {
        return powerFormatByPowerUnitAndPrecision(numberUtils.mul(data, power), power, unit - 1, n, r);
    }
    if (Number(data) >= Number(power)) {
        return powerFormatByPowerUnitAndPrecision(numberUtils.div(data, power, 48), power, unit + 1, n, r);
    }

    return ""
}

const getUnitStr1 = (unit) => {
    switch (unit) {
        case POW_POWER_UNIT_HASH:

            return "H/s";

        case POW_POWER_UNIT_KH:

            return "KH/s";

        case POW_POWER_UNIT_MH:

            return "MH/s";

        case POW_POWER_UNIT_GH:

            return "GH/s";

        case POW_POWER_UNIT_TH:

            return "TH/s";

        case POW_POWER_UNIT_PH:

            return "PH/s";

        case POW_POWER_UNIT_EH:

            return "EH/s";

        case POW_POWER_UNIT_ZH:

            return "ZH/s";

        case POW_POWER_UNIT_YH:

            return "YH/s";

        case POW_POWER_UNIT_BH:

            return "BH/s";

        case POW_POWER_UNIT_NH:

            return "NH/s";

        case POW_POWER_UNIT_DH:

            return "DH/s";
        default:
            return '';
    }
}

/**
 *
 */
const POWER_UNIT_BIT = 1;
const POWER_UNIT_KIB = 2;
const POWER_UNIT_MIB = 3;
const POWER_UNIT_GIB = 4;
const POWER_UNIT_TIB = 5;
const POWER_UNIT_PIB = 6;
const POWER_UNIT_EIB = 7;
const POWER_UNIT_ZIB = 8;
const POWER_UNIT_YIB = 9;
const POWER_UNIT_BIB = 10;
const POWER_UNIT_NIB = 11;
const POWER_UNIT_DIB = 12;

/**
 *
 */
const POW_POWER_UNIT_HASH = 1;
const POW_POWER_UNIT_KH = 2;
const POW_POWER_UNIT_MH = 3;
const POW_POWER_UNIT_GH = 4;
const POW_POWER_UNIT_TH = 5;
const POW_POWER_UNIT_PH = 6;
const POW_POWER_UNIT_EH = 7;
const POW_POWER_UNIT_ZH = 8;
const POW_POWER_UNIT_YH = 9;
const POW_POWER_UNIT_BH = 10;
const POW_POWER_UNIT_NH = 11;
const POW_POWER_UNIT_DH = 12;

export default {
    toNonExponential,
    toNonExponentialRow,
    toNonExponentialByValue,
    toNonExponentialByValueAndFixed,
    secondsFormatRow,
    secondsFormat,
    dateTimeFormatRow,
    dateFormatRow,
    dateFormatByDate,
    dateFormatByDateAndPattern,
    dateSecondsFormatRow,
    dateSecondsFormatByDate,
    getBeijingTime,
    optionsFormat,
    jsonFormat,
    // pwdFormat,
    // pwdFormatByPreKey,
    textFormat,
    powerFormat,
    powerFormatRow,
    powerFormatByUnit,
    powerFormatByPrecision,
    powerFormatByUnitAndPrecision,
    symbolFormat,
    symbolFormatBylimit,
    powerFormatByPowerPrecision
}



// WEBPACK FOOTER //
// ./src/models/commonFormat.js